import * as stylex from "@stylexjs/stylex";
export const resourceMarker = {
  xhc9rto: "xhc9rto",
  $$css: true
};
export const functionFieldMarker = {
  xzqtahw: "xzqtahw",
  $$css: true
};
export const searchMarker = {
  xpv7wew: "xpv7wew",
  $$css: true
};
export const splitMarker = {
  xfe7loh: "xfe7loh",
  $$css: true
};
export const tabMarker = {
  xtp3ge4: "xtp3ge4",
  $$css: true
};
export const credentialRowMarker = {
  x1i7rb0u: "x1i7rb0u",
  $$css: true
};
import "/home/runner/work/cf-effect-experiment/cf-effect-experiment/packages/vite-shared-libraries/src/LayerAnchors.ts";